import { createFileRoute } from "@tanstack/react-router";
import { Lists } from "../app/views/lists/lists";

export const Route = createFileRoute("/todo")({
  component: Lists,
});
